if (document.documentMode) {
  document.querySelector('html').classList.add('ie')
}
